module.exports = __webpack_public_path__ + "static/media/22-7.e47dff52.mp3";